export const pageExtrasPt = {
  cookieConsent: {
    ariaLabel: 'Consentimento de cookies',
    message:
      'Utilizamos cookies essenciais e analíticos para melhorar a sua experiência. Ao continuar, concorda com a nossa Política de Privacidade.',
    learnMore: 'Saber mais',
    accept: 'Aceitar',
    reject: 'Recusar',
  },
  floatingSocial: {
    ariaLabel: 'Redes sociais',
    whatsapp: 'Fale connosco no WhatsApp',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    facebook: 'Facebook',
  },
  common: {
    legal: 'Legal',
    email: 'E-mail:',
    phone: 'Telefone:',
    address: 'Endereço:',
    close: 'Fechar',
    nd: 'N/D',
    department: 'Departamento',
    location: 'Localização',
    type: 'Tipo',
    salary: 'Salário',
    job: 'Vaga',
    fullTime: 'Tempo integral',
    locationTbd: 'Local a definir',
    experienceTbd: 'Experiência a definir',
    notSpecified: 'Não especificado',
    requirementsTbd: 'Requisitos não especificados',
    benefitsTbd: 'Benefícios não especificados',
  },
  contactPageExtra: {
    eyebrow: 'Contacto',
    heroH1: 'Vamos conversar.',
    heroLead: 'Conte-nos sobre o seu projecto. Respondemos em até 24 horas úteis.',
    nextStep: 'Próximo passo',
    nextStepH2: 'Conte-nos o desafio.',
    nextStepP1:
      'Cada projecto começa com uma boa conversa. Apresente o contexto, as restrições e os objectivos e a nossa equipa propõe um caminho com base técnica e foco em resultado.',
    nextStepP2: 'Resposta em até 24 horas úteis.',
    channels: 'Canais directos',
    channelsH2: 'Como podemos ajudar.',
    hq: 'Sede',
    whatsapp: 'WhatsApp',
    responseTime: 'Tempo de resposta',
    responseVal: 'Até 24 horas úteis',
    contentHub: 'Central de Conteúdo',
    contentHubLead: 'Veja novidades e guias rápidos no blog institucional antes de abrir um contacto.',
    contentHubCta: 'Ver conteúdos →',
    formSection: 'Formulário',
    formH2: 'Conte-nos sobre o projecto.',
    formLead: 'Preencha os campos abaixo e entraremos em contacto o mais rápido possível.',
    contactType: 'Tipo de Contato',
    individual: 'Pessoa Individual',
    company: 'Empresa',
    fullName: 'Nome Completo',
    companyName: 'Nome da Empresa',
    namePh: 'Seu nome completo',
    companyPh: 'Nome da sua empresa',
    emailPh: 'seu@email.com',
    phonePh: '999 999 999',
    reason: 'Motivo do Contato',
    reasonPh: 'Selecione o motivo',
    subjectPh: 'Assunto da sua mensagem',
    messagePh: 'Descreva sua dúvida, sugestão ou solicitação...',
    privacyNote:
      'Seus dados serão utilizados apenas para responder sua mensagem e não serão compartilhados com terceiros. Ao enviar este formulário, você concorda com nossa política de privacidade.',
    privacyLabel: 'Política de Privacidade:',
    submit: 'Enviar Mensagem',
    sending: 'Enviando...',
    successTitle: 'Mensagem enviada com sucesso!',
    successMessage: 'Entraremos em contato em breve.',
    successInlineTitle: 'Mensagem Enviada!',
    successInlineBody: 'Obrigado pelo contato. A nossa equipa analisará a sua mensagem e responderá em breve.',
    sendAnother: 'Enviar Nova Mensagem',
    invalidForm: 'Verifique os campos obrigatórios do formulário.',
    sendError: 'Erro ao enviar mensagem',
    serverError: 'Erro interno do servidor',
    valName: 'Nome deve ter pelo menos 2 caracteres',
    valEmailRequired: 'E-mail é obrigatório',
    valEmailInvalid: 'E-mail inválido',
    valReason: 'Motivo do contato é obrigatório',
    valSubject: 'Assunto deve ter pelo menos 5 caracteres',
    valMessage: 'Mensagem deve ter pelo menos 10 caracteres',
    reasonQuote: 'Cotação',
    reasonPartnership: 'Parceria',
    reasonServices: 'Informações sobre Serviços',
    reasonSupport: 'Suporte Técnico',
    reasonComplaint: 'Reclamação',
    reasonSuggestion: 'Sugestão',
    reasonBudget: 'Orçamento',
    reasonConsulting: 'Consultoria',
    reasonInvestment: 'Investimento',
    reasonRecruitment: 'Recrutamento',
    reasonPress: 'Imprensa',
    reasonOther: 'Outros',
  },
  blogPageExtra2: {
    heroEyebrow: 'Notícias',
    heroH1: 'Novidades, projectos e oportunidades.',
    heroLead: 'Acompanhe a actividade da SOSVOR: vagas, parcerias, projectos entregues e formações.',
    pressRoom: 'Sala de imprensa',
    pressH2: 'A nossa actividade, em primeira mão.',
    pressLead:
      'Acompanhe entregas de projectos, parcerias estratégicas, formações e oportunidades de carreira directamente da fonte. Conteúdos curados pela equipa SOSVOR.',
    empty: 'Sem notícias publicadas. Volte em breve.',
  },
  postDetail: {
    loading: 'A carregar artigo…',
    notFound: 'Artigo não encontrado',
    notFoundBody: 'O artigo que procura não existe ou ainda não foi publicado.',
    back: 'Voltar ao Blog',
    share: 'Partilhar',
    gallery: 'Galeria',
    tags: 'Tags',
    related: 'Artigos relacionados',
    linkCopied: 'Link copiado para a área de transferência!',
  },
  jobDetail: {
    notFound: 'Vaga não encontrada',
    notFoundBody: 'A vaga que procura não existe ou foi removida.',
    back: 'Voltar para vagas',
    about: 'Sobre a vaga',
    summary: 'Resumo da vaga',
    responsibilities: 'Responsabilidades',
    requirements: 'Requisitos',
    benefits: 'Benefícios',
    applyNow: 'Candidatar-se agora',
    salaryTbd: 'A combinar',
  },
  jobApplication: {
    title: 'Candidatar-se à Vaga',
    notFound: 'Vaga não encontrada',
    back: 'Voltar para Vagas',
    loadError: 'Erro ao carregar vaga',
    formTitle: 'Formulário de Candidatura',
    requirements: 'Requisitos',
    benefits: 'Benefícios',
  },
  recruitmentForm: {
    spontaneousTitle: 'Candidatura Espontânea',
    applyTitle: 'Candidatar-se à Vaga',
    jobLabel: 'Vaga: {{title}}',
    description: 'Preencha os campos obrigatórios para concluir a sua candidatura.',
    fullName: 'Nome Completo',
    email: 'Email',
    phone: 'Telefone',
    location: 'Localização',
    currentRole: 'Cargo Atual',
    experience: 'Anos de Experiência',
    education: 'Formação',
    salary: 'Expectativa Salarial',
    skills: 'Competências',
    motivation: 'Carta de Motivação',
    linkedin: 'LinkedIn (opcional)',
    portfolio: 'Portfolio/Website (opcional)',
    attachments: 'Anexar Documentos',
    attachmentsHelp: 'Formatos aceitos: PDF, DOC, DOCX (máx. 5MB)',
    selectFiles: 'Selecionar Arquivos',
    additional: 'Informações Adicionais',
    submit: 'Enviar Candidatura',
    sending: 'Enviando...',
    successTitle: 'Candidatura Enviada!',
    successBody: 'A sua candidatura foi recebida com sucesso. A nossa equipa de RH entrará em contacto em breve.',
    sendAnother: 'Enviar Nova Candidatura',
    successToast: 'Candidatura enviada com sucesso!',
    errorToast: 'Erro ao enviar candidatura. Tente novamente.',
    valName: 'Nome deve ter pelo menos 2 caracteres',
    valEmail: 'Email inválido',
    valPhone: 'Telefone deve ter pelo menos 9 dígitos',
    valLocation: 'Localização é obrigatória',
    phName: 'Seu nome completo',
    phEmail: 'seu@email.com',
    phPhone: '+244 999 999 999',
    phLocation: 'Cidade, País',
    phRole: 'Seu cargo atual',
    phExperience: 'Ex.: 3-5 anos',
    phEducation: 'Ex.: Superior Completo',
    phSalary: 'Ex.: A combinar',
    phSkills: 'Principais competências e habilidades...',
    phMotivation: 'Conte-nos por que deseja trabalhar connosco...',
    phLinkedin: 'https://linkedin.com/in/seu-perfil',
    phPortfolio: 'https://seu-portfolio.com',
    phAdditional: 'Algo mais que gostaria de partilhar...',
  },
  recruitmentPageExtra2: {
    culture: 'Cultura',
    opportunities: 'Oportunidades atuais',
    activeJob: 'vaga ativa',
    activeJobs: 'vagas ativas',
    searchPh: 'Pesquisar vaga por palavra-chave...',
    allCategories: 'Todas as categorias',
    allLocations: 'Todos os locais',
  },
}

export const pageExtrasEn = {
  cookieConsent: {
    ariaLabel: 'Cookie consent',
    message:
      'We use essential and analytics cookies to improve your experience. By continuing, you agree to our Privacy Policy.',
    learnMore: 'Learn more',
    accept: 'Accept',
    reject: 'Decline',
  },
  floatingSocial: {
    ariaLabel: 'Social media',
    whatsapp: 'Chat with us on WhatsApp',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    facebook: 'Facebook',
  },
  common: {
    legal: 'Legal',
    email: 'Email:',
    phone: 'Phone:',
    address: 'Address:',
    close: 'Close',
    nd: 'N/A',
    department: 'Department',
    location: 'Location',
    type: 'Type',
    salary: 'Salary',
    job: 'Role',
    fullTime: 'Full-time',
    locationTbd: 'Location TBD',
    experienceTbd: 'Experience TBD',
    notSpecified: 'Not specified',
    requirementsTbd: 'Requirements not specified',
    benefitsTbd: 'Benefits not specified',
  },
  contactPageExtra: {
    eyebrow: 'Contact',
    heroH1: "Let's talk.",
    heroLead: 'Tell us about your project. We respond within 24 business hours.',
    nextStep: 'Next step',
    nextStepH2: 'Tell us the challenge.',
    nextStepP1:
      'Every project starts with a good conversation. Share the context, constraints and goals and our team will propose a path with technical grounding and results focus.',
    nextStepP2: 'Response within 24 business hours.',
    channels: 'Direct channels',
    channelsH2: 'How we can help.',
    hq: 'Head office',
    whatsapp: 'WhatsApp',
    responseTime: 'Response time',
    responseVal: 'Up to 24 business hours',
    contentHub: 'Content hub',
    contentHubLead: 'Browse news and quick guides on our blog before reaching out.',
    contentHubCta: 'View content →',
    formSection: 'Form',
    formH2: 'Tell us about the project.',
    formLead: 'Fill in the fields below and we will get back to you as soon as possible.',
    contactType: 'Contact type',
    individual: 'Individual',
    company: 'Company',
    fullName: 'Full name',
    companyName: 'Company name',
    namePh: 'Your full name',
    companyPh: 'Your company name',
    emailPh: 'you@email.com',
    phonePh: '999 999 999',
    reason: 'Reason for contact',
    reasonPh: 'Select a reason',
    subjectPh: 'Subject of your message',
    messagePh: 'Describe your question, suggestion or request...',
    privacyNote:
      'Your data will only be used to reply to your message and will not be shared with third parties. By submitting this form, you agree to our privacy policy.',
    privacyLabel: 'Privacy Policy:',
    submit: 'Send message',
    sending: 'Sending...',
    successTitle: 'Message sent successfully!',
    successMessage: 'We will contact you shortly.',
    successInlineTitle: 'Message sent!',
    successInlineBody: 'Thank you for contacting us. Our team will review your message and respond soon.',
    sendAnother: 'Send another message',
    invalidForm: 'Please check the required form fields.',
    sendError: 'Error sending message',
    serverError: 'Internal server error',
    valName: 'Name must be at least 2 characters',
    valEmailRequired: 'Email is required',
    valEmailInvalid: 'Invalid email',
    valReason: 'Reason for contact is required',
    valSubject: 'Subject must be at least 5 characters',
    valMessage: 'Message must be at least 10 characters',
    reasonQuote: 'Quote',
    reasonPartnership: 'Partnership',
    reasonServices: 'Service information',
    reasonSupport: 'Technical support',
    reasonComplaint: 'Complaint',
    reasonSuggestion: 'Suggestion',
    reasonBudget: 'Budget',
    reasonConsulting: 'Consulting',
    reasonInvestment: 'Investment',
    reasonRecruitment: 'Recruitment',
    reasonPress: 'Press',
    reasonOther: 'Other',
  },
  blogPageExtra2: {
    heroEyebrow: 'News',
    heroH1: 'Updates, projects and opportunities.',
    heroLead: 'Follow SOSVOR activity: jobs, partnerships, delivered projects and training.',
    pressRoom: 'Press room',
    pressH2: 'Our activity, first-hand.',
    pressLead:
      'Follow project deliveries, strategic partnerships, training and career opportunities straight from the source. Curated by the SOSVOR team.',
    empty: 'No published news yet. Check back soon.',
  },
  postDetail: {
    loading: 'Loading article…',
    notFound: 'Article not found',
    notFoundBody: 'The article you are looking for does not exist or has not been published yet.',
    back: 'Back to Blog',
    share: 'Share',
    gallery: 'Gallery',
    tags: 'Tags',
    related: 'Related articles',
    linkCopied: 'Link copied to clipboard!',
  },
  jobDetail: {
    notFound: 'Job not found',
    notFoundBody: 'The job you are looking for does not exist or has been removed.',
    back: 'Back to jobs',
    about: 'About the role',
    summary: 'Role summary',
    responsibilities: 'Responsibilities',
    requirements: 'Requirements',
    benefits: 'Benefits',
    applyNow: 'Apply now',
    salaryTbd: 'To be agreed',
  },
  jobApplication: {
    title: 'Apply for this role',
    notFound: 'Job not found',
    back: 'Back to jobs',
    loadError: 'Error loading job',
    formTitle: 'Application form',
    requirements: 'Requirements',
    benefits: 'Benefits',
  },
  recruitmentForm: {
    spontaneousTitle: 'Spontaneous application',
    applyTitle: 'Apply for this role',
    jobLabel: 'Role: {{title}}',
    description: 'Complete the required fields to submit your application.',
    fullName: 'Full name',
    email: 'Email',
    phone: 'Phone',
    location: 'Location',
    currentRole: 'Current role',
    experience: 'Years of experience',
    education: 'Education',
    salary: 'Salary expectation',
    skills: 'Skills',
    motivation: 'Cover letter',
    linkedin: 'LinkedIn (optional)',
    portfolio: 'Portfolio/Website (optional)',
    attachments: 'Attach documents',
    attachmentsHelp: 'Accepted formats: PDF, DOC, DOCX (max. 5MB)',
    selectFiles: 'Select files',
    additional: 'Additional information',
    submit: 'Submit application',
    sending: 'Sending...',
    successTitle: 'Application sent!',
    successBody: 'Your application was received successfully. Our HR team will contact you soon.',
    sendAnother: 'Submit another application',
    successToast: 'Application sent successfully!',
    errorToast: 'Error sending application. Please try again.',
    valName: 'Name must be at least 2 characters',
    valEmail: 'Invalid email',
    valPhone: 'Phone must be at least 9 digits',
    valLocation: 'Location is required',
    phName: 'Your full name',
    phEmail: 'you@email.com',
    phPhone: '+244 999 999 999',
    phLocation: 'City, Country',
    phRole: 'Your current role',
    phExperience: 'E.g. 3–5 years',
    phEducation: 'E.g. Bachelor’s degree',
    phSalary: 'E.g. To be agreed',
    phSkills: 'Key skills and competencies...',
    phMotivation: 'Tell us why you want to work with us...',
    phLinkedin: 'https://linkedin.com/in/your-profile',
    phPortfolio: 'https://your-portfolio.com',
    phAdditional: 'Anything else you would like to share...',
  },
  recruitmentPageExtra2: {
    culture: 'Culture',
    opportunities: 'Current opportunities',
    activeJob: 'active role',
    activeJobs: 'active roles',
    searchPh: 'Search jobs by keyword...',
    allCategories: 'All categories',
    allLocations: 'All locations',
  },
}

export const pageExtrasFr = {
  cookieConsent: {
    ariaLabel: 'Consentement aux cookies',
    message:
      'Nous utilisons des cookies essentiels et analytiques pour améliorer votre expérience. En continuant, vous acceptez notre Politique de confidentialité.',
    learnMore: 'En savoir plus',
    accept: 'Accepter',
    reject: 'Refuser',
  },
  floatingSocial: {
    ariaLabel: 'Réseaux sociaux',
    whatsapp: 'Contactez-nous sur WhatsApp',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    facebook: 'Facebook',
  },
  common: {
    legal: 'Juridique',
    email: 'E-mail :',
    phone: 'Téléphone :',
    address: 'Adresse :',
    close: 'Fermer',
    nd: 'N/D',
    department: 'Département',
    location: 'Localisation',
    type: 'Type',
    salary: 'Salaire',
    job: 'Poste',
    fullTime: 'Temps plein',
    locationTbd: 'Lieu à définir',
    experienceTbd: 'Expérience à définir',
    notSpecified: 'Non spécifié',
    requirementsTbd: 'Exigences non spécifiées',
    benefitsTbd: 'Avantages non spécifiés',
  },
  contactPageExtra: {
    eyebrow: 'Contact',
    heroH1: 'Parlons-en.',
    heroLead: 'Parlez-nous de votre projet. Nous répondons sous 24 heures ouvrées.',
    nextStep: 'Prochaine étape',
    nextStepH2: 'Parlez-nous du défi.',
    nextStepP1:
      'Chaque projet commence par une bonne conversation. Présentez le contexte, les contraintes et les objectifs et notre équipe proposera une approche technique orientée résultats.',
    nextStepP2: 'Réponse sous 24 heures ouvrées.',
    channels: 'Canaux directs',
    channelsH2: 'Comment nous pouvons aider.',
    hq: 'Siège',
    whatsapp: 'WhatsApp',
    responseTime: 'Délai de réponse',
    responseVal: "Jusqu'à 24 heures ouvrées",
    contentHub: 'Centre de contenu',
    contentHubLead: 'Consultez les actualités et guides sur notre blog avant de nous contacter.',
    contentHubCta: 'Voir les contenus →',
    formSection: 'Formulaire',
    formH2: 'Parlez-nous du projet.',
    formLead: 'Remplissez les champs ci-dessous et nous vous contacterons dès que possible.',
    contactType: 'Type de contact',
    individual: 'Particulier',
    company: 'Entreprise',
    fullName: 'Nom complet',
    companyName: "Nom de l'entreprise",
    namePh: 'Votre nom complet',
    companyPh: 'Nom de votre entreprise',
    emailPh: 'vous@email.com',
    phonePh: '999 999 999',
    reason: 'Motif du contact',
    reasonPh: 'Sélectionnez un motif',
    subjectPh: 'Objet de votre message',
    messagePh: 'Décrivez votre question, suggestion ou demande...',
    privacyNote:
      'Vos données seront utilisées uniquement pour répondre à votre message et ne seront pas partagées avec des tiers. En envoyant ce formulaire, vous acceptez notre politique de confidentialité.',
    privacyLabel: 'Politique de confidentialité :',
    submit: 'Envoyer le message',
    sending: 'Envoi...',
    successTitle: 'Message envoyé avec succès !',
    successMessage: 'Nous vous contacterons bientôt.',
    successInlineTitle: 'Message envoyé !',
    successInlineBody: 'Merci pour votre contact. Notre équipe analysera votre message et répondra bientôt.',
    sendAnother: 'Envoyer un nouveau message',
    invalidForm: 'Veuillez vérifier les champs obligatoires du formulaire.',
    sendError: "Erreur lors de l'envoi du message",
    serverError: 'Erreur interne du serveur',
    valName: 'Le nom doit comporter au moins 2 caractères',
    valEmailRequired: "L'e-mail est obligatoire",
    valEmailInvalid: 'E-mail invalide',
    valReason: 'Le motif du contact est obligatoire',
    valSubject: "L'objet doit comporter au moins 5 caractères",
    valMessage: 'Le message doit comporter au moins 10 caractères',
    reasonQuote: 'Devis',
    reasonPartnership: 'Partenariat',
    reasonServices: 'Informations sur les services',
    reasonSupport: 'Support technique',
    reasonComplaint: 'Réclamation',
    reasonSuggestion: 'Suggestion',
    reasonBudget: 'Budget',
    reasonConsulting: 'Conseil',
    reasonInvestment: 'Investissement',
    reasonRecruitment: 'Recrutement',
    reasonPress: 'Presse',
    reasonOther: 'Autres',
  },
  blogPageExtra2: {
    heroEyebrow: 'Actualités',
    heroH1: 'Nouveautés, projets et opportunités.',
    heroLead: "Suivez l'activité SOSVOR : offres, partenariats, projets livrés et formations.",
    pressRoom: 'Salle de presse',
    pressH2: 'Notre activité, en direct.',
    pressLead:
      'Suivez les livraisons de projets, partenariats stratégiques, formations et opportunités de carrière directement à la source. Contenus sélectionnés par l’équipe SOSVOR.',
    empty: 'Aucune actualité publiée pour le moment. Revenez bientôt.',
  },
  postDetail: {
    loading: "Chargement de l'article…",
    notFound: 'Article introuvable',
    notFoundBody: "L'article que vous recherchez n'existe pas ou n'a pas encore été publié.",
    back: 'Retour au blog',
    share: 'Partager',
    gallery: 'Galerie',
    tags: 'Tags',
    related: 'Articles associés',
    linkCopied: 'Lien copié dans le presse-papiers !',
  },
  jobDetail: {
    notFound: 'Offre introuvable',
    notFoundBody: "L'offre que vous recherchez n'existe pas ou a été supprimée.",
    back: 'Retour aux offres',
    about: 'À propos du poste',
    summary: 'Résumé du poste',
    responsibilities: 'Responsabilités',
    requirements: 'Exigences',
    benefits: 'Avantages',
    applyNow: 'Postuler maintenant',
    salaryTbd: 'À négocier',
  },
  jobApplication: {
    title: 'Postuler à cette offre',
    notFound: 'Offre introuvable',
    back: 'Retour aux offres',
    loadError: "Erreur de chargement de l'offre",
    formTitle: 'Formulaire de candidature',
    requirements: 'Exigences',
    benefits: 'Avantages',
  },
  recruitmentForm: {
    spontaneousTitle: 'Candidature spontanée',
    applyTitle: 'Postuler à cette offre',
    jobLabel: 'Poste : {{title}}',
    description: 'Remplissez les champs obligatoires pour soumettre votre candidature.',
    fullName: 'Nom complet',
    email: 'E-mail',
    phone: 'Téléphone',
    location: 'Localisation',
    currentRole: 'Poste actuel',
    experience: "Années d'expérience",
    education: 'Formation',
    salary: 'Prétention salariale',
    skills: 'Compétences',
    motivation: 'Lettre de motivation',
    linkedin: 'LinkedIn (optionnel)',
    portfolio: 'Portfolio/Site web (optionnel)',
    attachments: 'Joindre des documents',
    attachmentsHelp: 'Formats acceptés : PDF, DOC, DOCX (max. 5 Mo)',
    selectFiles: 'Sélectionner des fichiers',
    additional: 'Informations complémentaires',
    submit: 'Envoyer la candidature',
    sending: 'Envoi...',
    successTitle: 'Candidature envoyée !',
    successBody: 'Votre candidature a bien été reçue. Notre équipe RH vous contactera bientôt.',
    sendAnother: 'Envoyer une nouvelle candidature',
    successToast: 'Candidature envoyée avec succès !',
    errorToast: "Erreur lors de l'envoi de la candidature. Veuillez réessayer.",
    valName: 'Le nom doit comporter au moins 2 caractères',
    valEmail: 'E-mail invalide',
    valPhone: 'Le téléphone doit comporter au moins 9 chiffres',
    valLocation: 'La localisation est obligatoire',
    phName: 'Votre nom complet',
    phEmail: 'vous@email.com',
    phPhone: '+244 999 999 999',
    phLocation: 'Ville, Pays',
    phRole: 'Votre poste actuel',
    phExperience: 'Ex. : 3–5 ans',
    phEducation: 'Ex. : Diplôme universitaire',
    phSalary: 'Ex. : À négocier',
    phSkills: 'Principales compétences...',
    phMotivation: 'Dites-nous pourquoi vous souhaitez nous rejoindre...',
    phLinkedin: 'https://linkedin.com/in/votre-profil',
    phPortfolio: 'https://votre-portfolio.com',
    phAdditional: "Autre chose que vous aimeriez partager...",
  },
  recruitmentPageExtra2: {
    culture: 'Culture',
    opportunities: 'Opportunités actuelles',
    activeJob: 'offre active',
    activeJobs: 'offres actives',
    searchPh: 'Rechercher une offre par mot-clé...',
    allCategories: 'Toutes les catégories',
    allLocations: 'Tous les lieux',
  },
}
